import { CheckoutRoute, SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { InitialCheckoutRoute } from "@checkout-main/interfaces/index";
import { SOURCE_CHANNEL } from "@swiggy-private/checkout-core";
import { CheckoutMainProps } from "@checkout-main/components/checkout-main";

export const getInitialCheckoutRoute = (headers: CheckoutMainProps["headers"]): InitialCheckoutRoute => {
    const xChannel = headers[SwgyHeaderKeysList.xChannel];

    switch (xChannel) {
        case SOURCE_CHANNEL.TOING_APP:
            return { name: CheckoutRoute.TOING_CART };
        default:
            return { name: CheckoutRoute.CART };
    }
};
